import { Body1Bold, Body3Regular } from '../../lib/font';
import { colors } from '../../lib/colors';
import styled from 'styled-components';
import { I_ERROR, I_GREEN_FILL_ALERT } from '../../types/images';
import { Row } from '../../lib/utils';
import WhiteSquareButton from '../Button/WhiteSquareButton';
import ColorSquareButton from '../Button/ColorSquareButton';
import SvgIcon from '../SvgIcon';

const ModalOverLay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #00000047;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10001;
`;

const ModalInner = styled.div`
    background: white;
    width: 540px;
    border-radius: 8px;
    box-shadow: 8px 8px 16px 0px #0000005c;
    position: relative; /* Ensure positioning context */
    padding-bottom: 24px; /* Add padding for the button */
`;

export type ModalAlertIcon = 'alert' | 'none';

type Props = {
    title: string | null;
    content: string | null;
    isError?: boolean;
    icon?: ModalAlertIcon;
    buttonContent?: string | null;
    callBack?: any;
    isTwoButton: boolean;
    twoButtonContent: string | null;
    twoButtonCallBack: any;
    alertStateReset: any;
};

const ModalAlertOneButton = ({
    title,
    content,
    isError,
    icon = 'alert',
    buttonContent = '확인',
    callBack,
    isTwoButton,
    twoButtonContent,
    twoButtonCallBack,
    alertStateReset,
}: Props) => {
    return (
        <ModalOverLay>
            <ModalInner>
                <Row
                    style={{
                        alignItems: 'center',
                        marginLeft: 24,
                        marginTop: 24,
                        marginBottom: 16,
                    }}
                >
                    {icon !== 'none' && <SvgIcon name={'SvgError'} size={24} fill={isError ? colors.ERROR : colors.SUCCESS} />}
                    <Body1Bold style={{ color: colors.LAVEL_4, marginLeft: icon === 'none' ? 0 : 12 }}>{title}</Body1Bold>
                </Row>
                <Row
                    style={{
                        width: icon === 'none' ? 492 : 456,
                        marginLeft: icon === 'none' ? 24 : 60,
                        marginBottom: 20,
                        whiteSpace: 'pre-wrap',
                    }}
                >
                    <Body3Regular style={{}}>{content}</Body3Regular>
                </Row>
                {isTwoButton === true ? (
                    // 고정폭(312)+고정마진(274) 배치는 긴 라벨에서 모달 밖으로 밀린다.
                    // 표준 위치(우측 정렬)는 유지하고 버튼만 라벨에 맞춰 늘어나게 한다.
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            gap: 16,
                            marginTop: 40,
                            paddingRight: 24,
                        }}
                    >
                        <WhiteSquareButton
                            text={twoButtonContent ? twoButtonContent : '취소'}
                            size="small"
                            callBack={() => {
                                twoButtonCallBack && twoButtonCallBack();
                                alertStateReset();
                            }}
                        />
                        <ColorSquareButton
                            text={buttonContent ?? '확인'}
                            size={'small'}
                            customStyle={{
                                width: 'auto',
                                minWidth: 113,
                                padding: '0 20px',
                                whiteSpace: 'nowrap',
                            }}
                            callBack={() => {
                                callBack && callBack();
                                alertStateReset();
                            }}
                        />
                    </div>
                ) : (
                    // 고정 marginLeft + 고정폭(113px)은 '소유자 프로필 열기' 같은 긴 라벨을
                    // 잘라먹는다. 우측 정렬 + 내용에 맞는 가변폭으로 어떤 라벨도 수용한다.
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 20, paddingRight: 24 }}>
                        <ColorSquareButton
                            text={buttonContent ?? '확인'}
                            size={'small'}
                            customStyle={{
                                width: 'auto',
                                minWidth: 113,
                                padding: '0 20px',
                                whiteSpace: 'nowrap',
                            }}
                            callBack={() => {
                                callBack && callBack();
                                alertStateReset();
                            }}
                        />
                    </div>
                )}
            </ModalInner>
        </ModalOverLay>
    );
};

export default ModalAlertOneButton;
